import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import RentalsHero from './components/RentalsHero';
import TrustBar from './components/TrustBar';
import RentalsGrid from './components/RentalsGrid';

export default function RentalsPage() {
  return (
    <div className="min-h-screen font-sans">
      <Navbar />
      <main>
        <RentalsHero />
        <RentalsGrid />
        <TrustBar />
        {/* Final CTA */}
        <section className="py-16 bg-navy-900 text-center">
          <div className="max-w-2xl mx-auto px-6">
            <h2 className="font-heading text-3xl font-bold text-white mb-3">
              Don&apos;t See What You&apos;re Looking For?
            </h2>
            <p className="text-white/60 text-base mb-7">
              New vacancies come up regularly. Get in touch and we&apos;ll let you know as soon as the right room becomes available.
            </p>
            <a
              href="/contact"
              className="inline-flex items-center gap-2 bg-gold-500 hover:bg-gold-400 text-navy-900 font-bold text-sm px-8 py-4 rounded transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-mail-send-line" />
              </div>
              Send Us an Enquiry
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
